'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}
var styled = _interopDefault(require('styled-components'));
var functions = require('@keytrade/functions');
var React = _interopDefault(require('react'));
var componentsSpan = require('@keytrade/components-span');
var componentsLink = require('@keytrade/components-link');
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function () {
    return !!t;
  })();
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == typeof e || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
function createCommonjsModule(fn, module) {
  return module = {
    exports: {}
  }, fn(module, module.exports), module.exports;
}
var focusVisible = createCommonjsModule(function (module, exports) {
  (function (global, factory) {
    factory();
  })(commonjsGlobal, function () {
    /**
     * Applies the :focus-visible polyfill at the given scope.
     * A scope in this case is either the top-level Document or a Shadow Root.
     *
     * @param {(Document|ShadowRoot)} scope
     * @see https://github.com/WICG/focus-visible
     */
    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        'datetime-local': true
      };

      /**
       * Helper function for legacy browsers and iframes which sometimes focus
       * elements like document, body, and non-interactive SVG.
       * @param {Element} el
       */
      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
          return true;
        }
        return false;
      }

      /**
       * Computes whether the given element should automatically trigger the
       * `focus-visible` class being added, i.e. whether it should always match
       * `:focus-visible` when focused.
       * @param {Element} el
       * @return {boolean}
       */
      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;
        if (tagName === 'INPUT' && inputTypesAllowlist[type] && !el.readOnly) {
          return true;
        }
        if (tagName === 'TEXTAREA' && !el.readOnly) {
          return true;
        }
        if (el.isContentEditable) {
          return true;
        }
        return false;
      }

      /**
       * Add the `focus-visible` class to the given element if it was not added by
       * the author.
       * @param {Element} el
       */
      function addFocusVisibleClass(el) {
        if (el.classList.contains('focus-visible')) {
          return;
        }
        el.classList.add('focus-visible');
        el.setAttribute('data-focus-visible-added', '');
      }

      /**
       * Remove the `focus-visible` class from the given element if it was not
       * originally added by the author.
       * @param {Element} el
       */
      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute('data-focus-visible-added')) {
          return;
        }
        el.classList.remove('focus-visible');
        el.removeAttribute('data-focus-visible-added');
      }

      /**
       * If the most recent user interaction was via the keyboard;
       * and the key press did not include a meta, alt/option, or control key;
       * then the modality is keyboard. Otherwise, the modality is not keyboard.
       * Apply `focus-visible` to any current active element and keep track
       * of our keyboard modality state with `hadKeyboardEvent`.
       * @param {KeyboardEvent} e
       */
      function onKeyDown(e) {
        if (e.metaKey || e.altKey || e.ctrlKey) {
          return;
        }
        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }
        hadKeyboardEvent = true;
      }

      /**
       * If at any point a user clicks with a pointing device, ensure that we change
       * the modality away from keyboard.
       * This avoids the situation where a user presses a key on an already focused
       * element, and then clicks on a different element, focusing it with a
       * pointing device, while we still think we're in keyboard modality.
       * @param {Event} e
       */
      function onPointerDown(e) {
        hadKeyboardEvent = false;
      }

      /**
       * On `focus`, add the `focus-visible` class to the target if:
       * - the target received focus as a result of keyboard navigation, or
       * - the event target is an element that will likely require interaction
       *   via the keyboard (e.g. a text box)
       * @param {Event} e
       */
      function onFocus(e) {
        // Prevent IE from focusing the document or HTML element.
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
          addFocusVisibleClass(e.target);
        }
      }

      /**
       * On `blur`, remove the `focus-visible` class from the target.
       * @param {Event} e
       */
      function onBlur(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (e.target.classList.contains('focus-visible') || e.target.hasAttribute('data-focus-visible-added')) {
          // To detect a tab/window switch, we look for a blur event followed
          // rapidly by a visibility change.
          // If we don't see a visibility change within 100ms, it's probably a
          // regular focus change.
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e.target);
        }
      }

      /**
       * If the user changes tabs, keep track of whether or not the previously
       * focused element had .focus-visible.
       * @param {Event} e
       */
      function onVisibilityChange(e) {
        if (document.visibilityState === 'hidden') {
          // If the tab becomes active again, the browser will handle calling focus
          // on the element (Safari actually calls it twice).
          // If this tab change caused a blur on an element with focus-visible,
          // re-apply the class when the user switches back to the tab.
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }

      /**
       * Add a group of listeners to detect usage of any pointing devices.
       * These listeners will be added when the polyfill first loads, and anytime
       * the window is blurred, so that they are active when the window regains
       * focus.
       */
      function addInitialPointerMoveListeners() {
        document.addEventListener('mousemove', onInitialPointerMove);
        document.addEventListener('mousedown', onInitialPointerMove);
        document.addEventListener('mouseup', onInitialPointerMove);
        document.addEventListener('pointermove', onInitialPointerMove);
        document.addEventListener('pointerdown', onInitialPointerMove);
        document.addEventListener('pointerup', onInitialPointerMove);
        document.addEventListener('touchmove', onInitialPointerMove);
        document.addEventListener('touchstart', onInitialPointerMove);
        document.addEventListener('touchend', onInitialPointerMove);
      }
      function removeInitialPointerMoveListeners() {
        document.removeEventListener('mousemove', onInitialPointerMove);
        document.removeEventListener('mousedown', onInitialPointerMove);
        document.removeEventListener('mouseup', onInitialPointerMove);
        document.removeEventListener('pointermove', onInitialPointerMove);
        document.removeEventListener('pointerdown', onInitialPointerMove);
        document.removeEventListener('pointerup', onInitialPointerMove);
        document.removeEventListener('touchmove', onInitialPointerMove);
        document.removeEventListener('touchstart', onInitialPointerMove);
        document.removeEventListener('touchend', onInitialPointerMove);
      }

      /**
       * When the polfyill first loads, assume the user is in keyboard modality.
       * If any event is received from a pointing device (e.g. mouse, pointer,
       * touch), turn off keyboard modality.
       * This accounts for situations where focus enters the page from the URL bar.
       * @param {Event} e
       */
      function onInitialPointerMove(e) {
        // Work around a Safari quirk that fires a mousemove on <html> whenever the
        // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
        if (e.target.nodeName && e.target.nodeName.toLowerCase() === 'html') {
          return;
        }
        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      }

      // For some kinds of state, we are interested in changes at the global scope
      // only. For example, global pointer input, global key presses and global
      // visibility change should affect the state at every scope:
      document.addEventListener('keydown', onKeyDown, true);
      document.addEventListener('mousedown', onPointerDown, true);
      document.addEventListener('pointerdown', onPointerDown, true);
      document.addEventListener('touchstart', onPointerDown, true);
      document.addEventListener('visibilitychange', onVisibilityChange, true);
      addInitialPointerMoveListeners();

      // For focus and blur, we specifically care about state changes in the local
      // scope. This is because focus / blur events that originate from within a
      // shadow root are not re-dispatched from the host element if it was already
      // the active element in its own scope:
      scope.addEventListener('focus', onFocus, true);
      scope.addEventListener('blur', onBlur, true);

      // We detect that a node is a ShadowRoot by ensuring that it is a
      // DocumentFragment and also has a host property. This check covers native
      // implementation and polyfill implementation transparently. If we only cared
      // about the native implementation, we could just check if the scope was
      // an instance of a ShadowRoot.
      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        // Since a ShadowRoot is a special kind of DocumentFragment, it does not
        // have a root element to add a class to. So, we add this attribute to the
        // host element instead:
        scope.host.setAttribute('data-js-focus-visible', '');
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add('js-focus-visible');
        document.documentElement.setAttribute('data-js-focus-visible', '');
      }
    }

    // It is important to wrap all references to global window and document in
    // these checks to support server-side rendering use cases
    // @see https://github.com/WICG/focus-visible/issues/199
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      // Make the polyfill helper globally available. This can be used as a signal
      // to interested libraries that wish to coordinate with the polyfill for e.g.,
      // applying the polyfill to a shadow root:
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;

      // Notify interested libraries of the polyfill's presence, in case the
      // polyfill was loaded lazily:
      var event;
      try {
        event = new CustomEvent('focus-visible-polyfill-ready');
      } catch (error) {
        // IE11 does not support using CustomEvent as a constructor directly:
        event = document.createEvent('CustomEvent');
        event.initCustomEvent('focus-visible-polyfill-ready', false, false, {});
      }
      window.dispatchEvent(event);
    }
    if (typeof document !== 'undefined') {
      // Apply the polyfill to the global document, so that no JavaScript
      // coordination is required to use the polyfill in the top-level document:
      applyFocusVisiblePolyfill(document);
    }
  });
});
var getFont = functions.config.fonts.getFont;
var colors = functions.config.colors.list;
var UmWrapper = styled.div.withConfig({
  displayName: "UrgentMessagestyled__UmWrapper",
  componentId: "sc-prpjfy-0"
})(["align-items:strecht;background-color:", ";color:", ";border-radius:1.2rem;border:none;display:flex;font-family:", ";justify-content:flex-start;margin:", ";overflow:hidden;padding:0;position:relative;font-size:1.6rem;width:100%;flex-direction:column;@media ", "{flex-direction:row;}box-shadow:0 0 2px rgba(0,0,0,0.14),0 2px 4px rgba(0,0,0,0.08);"], colors.White, colors.BlueDark, function (_ref) {
  var theme = _ref.theme;
  return theme.fontFamily ? theme.fontFamily : getFont(theme, 'regular');
}, function (props) {
  return props.margin;
}, functions.config.breakpoints.device.tablet);
var UmTitleWrapper = styled.div.withConfig({
  displayName: "UrgentMessagestyled__UmTitleWrapper",
  componentId: "sc-prpjfy-1"
})(["flex:0 0 auto;background-color:", ";display:flex;flex-wrap:no-wrap;justify-content:flex-start;align-items:center;padding:1.2rem 1.8rem;font-family:", ";white-space:nowrap;flex-direction:row;font-size:1.6rem;&,span{text-overflow:ellipsis;overflow:hidden;}"], function (props) {
  return colors[props.bgColor];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily ? theme.fontFamily : getFont(theme, 'bold');
});
var UmTitleIconWrapper = styled.div.withConfig({
  displayName: "UrgentMessagestyled__UmTitleIconWrapper",
  componentId: "sc-prpjfy-2"
})(["margin-right:1.2rem;line-height:1;padding:0;position:relative;top:1.4px;"]);
var UmContentWrapper = styled.div.withConfig({
  displayName: "UrgentMessagestyled__UmContentWrapper",
  componentId: "sc-prpjfy-3"
})(["flex:1 1 auto;padding:1.2rem 2.3rem;font-family:inherit;font-size:1.6rem;@media ", "{padding:", ";display:flex;margin-left:auto;self-align:flex-end;align-items:center;max-width:100%;}"], functions.config.breakpoints.device.tablet, function (props) {
  return props.hasClose ? '1.2rem 4.4rem 1.2rem 2.3rem' : '1.2rem 2.3rem';
});
var ContentContainer = styled.span.withConfig({
  displayName: "UrgentMessagestyled__ContentContainer",
  componentId: "sc-prpjfy-4"
})(["@media ", "{flex:0 1 auto;display:block;}"], functions.config.breakpoints.device.tablet);
var LinkContainer = styled.span.withConfig({
  displayName: "UrgentMessagestyled__LinkContainer",
  componentId: "sc-prpjfy-5"
})(["margin-left:20px;white-space:nowrap;@media ", "{display:block;flex:0 0 auto;}"], functions.config.breakpoints.device.tablet);
var UmLinkWrapper = styled.div.withConfig({
  displayName: "UrgentMessagestyled__UmLinkWrapper",
  componentId: "sc-prpjfy-6"
})(["flex:0 1 auto;padding:0 2.3rem 2.3rem;margin-left:auto;self-align:flex-end;font-family:inherit;font-size:inherit;white-space:nowrap;text-decoration:underline;@media ", "{display:flex;padding:2.3rem;margin-left:auto;self-align:flex-end;align-items:center;}"], functions.config.breakpoints.device.tablet);
var UmCloseWrapper = styled.button.withConfig({
  displayName: "UrgentMessagestyled__UmCloseWrapper",
  componentId: "sc-prpjfy-7"
})(["background-color:transparent;border:none;cursor:pointer;border-radius:.3rem;font-size:0;&:focus{outline:none;}&.focus-visible{background-color:", ";}@media ", "{padding:.2rem;position:relative;top:8px;}"], colors.WhiteTransparent, functions.config.breakpoints.deviceDown.tablet);
var UmCloseIcon = styled.div.withConfig({
  displayName: "UrgentMessagestyled__UmCloseIcon",
  componentId: "sc-prpjfy-8"
})(["@media ", "{display:block;position:absolute;right:1.6rem;top:.5rem;flex:0 0 auto;height:2rem;width:2rem;}@media ", "{display:flex;margin-right:.8rem;}"], functions.config.breakpoints.deviceDown.tablet, functions.config.breakpoints.device.tablet);
var colors$1 = functions.config.colors.list;
var IcnCross = function IcnCross(props) {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "2rem",
    height: "2rem",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: colors$1.BlueDark,
    fillRule: "evenodd",
    d: "M13.9 12.25l5.42-5.42a.5.5 0 0 0 0-.71l-.94-.94a.5.5 0 0 0-.71 0l-5.42 5.42-5.42-5.42a.5.5 0 0 0-.71 0l-.94.94a.5.5 0 0 0 0 .71l5.42 5.42-5.42 5.42a.5.5 0 0 0 0 .71l.94.94a.5.5 0 0 0 .71 0l5.42-5.42 5.42 5.42a.5.5 0 0 0 .71 0l.94-.94a.5.5 0 0 0 0-.71l-5.42-5.42z"
  }));
};
var colors$2 = functions.config.colors.list;
var IcnInfo = function IcnInfo(props) {
  return /*#__PURE__*/React.createElement("svg", {
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "2.4rem",
    height: "2.4rem",
    viewBox: "0 0 24 24",
    className: props.className,
    style: props.style
  }, /*#__PURE__*/React.createElement("path", {
    fill: colors$2[props.color],
    fillRule: "evenodd",
    d: "M12 4a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm-.5 5.5a1 1 0 0 1 .993.883l.007.117V14a.5.5 0 0 0 .41.492l.09.008h.5a.5.5 0 0 1 .09.992l-.09.008H13a1.5 1.5 0 0 1-1.493-1.356L11.5 14v-2.5H11a.5.5 0 0 1-.09-.992L11 10.5h.5zm.25-2.5l.102.007a.75.75 0 1 1-.204 0L11.75 8z"
  }));
};
var types = {
  promo: {
    backgroundColor: 'AeroBlue',
    textColor: 'GreenGarden'
  },
  alert: {
    backgroundColor: 'MistyRose',
    textColor: 'Tomato'
  },
  information: {
    backgroundColor: 'BlueSmoke',
    textColor: 'BlueMoon'
  }
};
var UrgentMessage = /*#__PURE__*/function (_React$Component) {
  function UrgentMessage() {
    var _this;
    _classCallCheck(this, UrgentMessage);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, UrgentMessage, [].concat(args));
    _defineProperty(_this, "state", {
      isClosed: false
    });
    return _this;
  }
  _inherits(UrgentMessage, _React$Component);
  return _createClass(UrgentMessage, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        content = _this$props.content,
        linkLabel = _this$props.linkLabel,
        linkUrl = _this$props.linkUrl,
        margin = _this$props.margin,
        onClose = _this$props.onClose,
        title = _this$props.title,
        type = _this$props.type;
      var isExternalUrl = function isExternalUrl(url) {
        // link is external or not ?
        var tmp = document.createElement('a');
        tmp.href = url;
        return tmp.host !== window.location.host;
      };
      return /*#__PURE__*/React.createElement(UmWrapper, {
        margin: margin
      }, /*#__PURE__*/React.createElement(UmTitleWrapper, {
        bgColor: types[type].backgroundColor,
        color: types[type].textColor
      }, /*#__PURE__*/React.createElement(UmTitleIconWrapper, null, /*#__PURE__*/React.createElement(IcnInfo, {
        color: types[type].textColor
      })), /*#__PURE__*/React.createElement(componentsSpan.Span, {
        size: "titleXxs",
        color: types[type].textColor,
        weight: "bold",
        title: title
      }, title)), /*#__PURE__*/React.createElement(UmContentWrapper, {
        title: content,
        hasClose: !!onClose
      }, /*#__PURE__*/React.createElement(ContentContainer, null, content), linkUrl && linkLabel && /*#__PURE__*/React.createElement(LinkContainer, null, /*#__PURE__*/React.createElement(componentsLink.Link, {
        href: linkUrl,
        inherit: true,
        targetBlank: isExternalUrl(linkUrl)
      }, linkLabel))), onClose && /*#__PURE__*/React.createElement(UmCloseIcon, null, /*#__PURE__*/React.createElement(UmCloseWrapper, {
        onClick: onClose
      }, /*#__PURE__*/React.createElement(IcnCross, null))));
    }
  }]);
}(React.Component);
exports.UrgentMessage = UrgentMessage;